export const LPinputField = ({labelText, placeholder, onChange, errorMessage, maxLength, ...props}) => {
    return(
        <>
            <label>
                <p className="block text-[11.5px] font-bold tracking-widest text-[#A9B4C7] mb-1.5">{labelText}</p>
            <input
                placeholder={placeholder}
                onChange={onChange}
                maxLength={maxLength}
                {...props}
                className={`block appearance-none w-full border border-[#33425E] bg-[#0E1B31] focus:border-[#C9A227] focus:bg-[#132342] focus:outline-none py-2.5 px-3.5 text-white placeholder:text-[#6C7A93] sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed read-only:cursor-default sm:leading-6 md:max-w-[390px] mb-2`}
            />
            </label>
            <p className="text-[#F0B7B7] text-xs min-h-5 mb-3">{errorMessage || ''}</p>
        </>
    )
}

export const LPtextField = ({labelText, labelId, placeholder, required, onChange, errorMessage, name, ...props}) => {
    return(
        <>
            <label>
                <p className="block text-[11.5px] font-bold tracking-widest text-[#A9B4C7] mb-1.5">{labelText}</p>
            </label>
            <textarea
              id={labelId}
              required={required}
              placeholder={placeholder}
              onChange={onChange}
              name={name}
              {...props}
              rows="4"
              className={`block w-full border border-[#33425E] bg-[#0E1B31] focus:border-[#C9A227] focus:bg-[#132342] focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed py-2.5 px-3.5 text-white placeholder:text-[#6C7A93] sm:text-sm sm:leading-6 md:max-w-[390px] mb-2`}
            />
            <p className="text-[#F0B7B7] text-xs min-h-5">{errorMessage || ''}</p>
        </>
    )
}

export const LPskeletonLoading = ({max_width}) => {
    return (
      <div className={`animate-pulse w-full ${max_width ? max_width :'min-w-20'}`}>
          <div className='h-4 w-full min-w-20 bg-gray-200 my-2 rounded'></div>
      </div>
    )
  }